// AUTO-GENERATED by sync-icons — do not edit.
import FacebookIconSvg from './FacebookIcon';
import InstagramIconSvg from './InstagramIcon';
import LinkedInIconSvg from './LinkedInIcon';
import ThumbDownIconSvg from './ThumbDownIcon';
import ThumbUpIconSvg from './ThumbUpIcon';
import WhatsAppIconSvg from './WhatsAppIcon';
import XIconSvg from './XIcon';
import YouTubeIconSvg from './YouTubeIcon';
import { withIconWrapper } from '../../IconWrapper';
export const FacebookIcon = withIconWrapper(FacebookIconSvg);
export const InstagramIcon = withIconWrapper(InstagramIconSvg);
export const LinkedInIcon = withIconWrapper(LinkedInIconSvg);
export const ThumbDownIcon = withIconWrapper(ThumbDownIconSvg);
export const ThumbUpIcon = withIconWrapper(ThumbUpIconSvg);
export const WhatsAppIcon = withIconWrapper(WhatsAppIconSvg);
export const XIcon = withIconWrapper(XIconSvg);
export const YouTubeIcon = withIconWrapper(YouTubeIconSvg);
